import axios from 'axios';

// Configure axios - we'll build full URLs in the interceptor
const hostname = window.location.hostname.toLowerCase();
const isProduction = hostname === 'patelhrms.com' 
  || hostname.includes('patelhrms.com')
  || hostname === 'vitreous.support'
  || hostname.includes('vitreous.support')
  || hostname === 'www.vitreous.support';
// In dev, use relative URLs so create-react-app proxy (→ localhost:5000) works
const API_ORIGIN = isProduction ? window.location.origin : '';

// Debug logging
console.log('[API Config] Hostname:', hostname, '| Is Production:', isProduction, '| API Origin:', API_ORIGIN);

// Create axios instance WITHOUT baseURL - we'll build full URLs manually
const api = axios.create({
  baseURL: '', // Empty - we'll build full URLs in interceptor
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token and normalize URL
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // CRITICAL FIX: Build full URL manually to ALWAYS include /api prefix
    if (config.url) {
      let path = config.url;
      
      // Normalize path: remove leading /api if present to avoid double /api/api
      if (path.startsWith('/api/')) {
        path = path.substring(4); // Remove '/api' (4 characters)
      } else if (path.startsWith('/api')) {
        path = path.substring(4); // Remove '/api' (4 characters)
      }
      
      // Ensure path starts with /
      if (!path.startsWith('/')) {
        path = '/' + path;
      }
      
      // Always add /api prefix
      path = '/api' + path;
      
      // Build full absolute URL
      config.url = API_ORIGIN + path;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect if we're on TV Dashboard - it has its own auth
      const isTVDashboard = window.location.pathname === '/tvdashboard' || window.location.pathname.startsWith('/tvdashboard');
      
      if (!isTVDashboard) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        if (window.location.pathname !== '/login') {
          // Preserve /chat so user returns to chat after re-login
          const returnUrl = window.location.pathname === '/chat' ? '?returnUrl=' + encodeURIComponent('/chat') : '';
          window.location.href = '/login' + returnUrl;
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
